import styled from 'styled-components'

export const Checkbox = styled.label`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 0;
    position: relative;
    font-size: 0.875rem !important;
    cursor: pointer;
    font-weight: 300 !important;

    &:hover {
        .checkbox {
            border-color: ${props => props.theme.admin.colors.brand};
        }
    }

    input {
        width: auto;
        margin-right: 15px;
        opacity: 0;
        visibility: hidden;
        height: 30px;
    }

    .checkbox {
        position: absolute;
        top: calc(50% - 10px);
        left: 0;

        display: inline-block;
        height: 19px;
        width: 19px;
        border: 1px solid ${props => props.theme.admin.font.color};
        transition: border 0.2s linear;
        background-color: #ffffff;
    }

    input:checked + .checkbox {
        &:before {
            content: '';
            display: block;
            height: 100%;
            width: 100%;
            background-image: url(data:image/svg+xml;base64,PHN2ZyBhcmlhLWhpZGRlbj0idHJ1ZSIgZm9jdXNhYmxlPSJmYWxzZSIgZGF0YS1wcmVmaXg9ImZhciIgZGF0YS1pY29uPSJjaGVjayIgY2xhc3M9InN2Zy1pbmxpbmUtLWZhIGZhLWNoZWNrIGZhLXctMTYgbXItMiIgcm9sZT0iaW1nIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1MTIgNTEyIj48cGF0aCBmaWxsPSIjMzM4Y2U0IiBkPSJNNDM1Ljg0OCA4My40NjZMMTcyLjgwNCAzNDYuNTFsLTk2LjY1Mi05Ni42NTJjLTQuNjg2LTQuNjg2LTEyLjI4NC00LjY4Ni0xNi45NzEgMGwtMjguMjg0IDI4LjI4NGMtNC42ODYgNC42ODYtNC42ODYgMTIuMjg0IDAgMTYuOTcxbDEzMy40MjEgMTMzLjQyMWM0LjY4NiA0LjY4NiAxMi4yODQgNC42ODYgMTYuOTcxIDBsMjk5LjgxMy0yOTkuODEzYzQuNjg2LTQuNjg2IDQuNjg2LTEyLjI4NCAwLTE2Ljk3MWwtMjguMjg0LTI4LjI4NGMtNC42ODYtNC42ODYtMTIuMjg0LTQuNjg2LTE2Ljk3IDB6Ij48L3BhdGg+PC9zdmc+);
            background-size: 12px;
            background-repeat: no-repeat;
            background-position: center;
        }
    }

    input:disabled + .checkbox {
        opacity: 0.5;
        cursor: not-allowed;
    }

    .checkbox-label {
        margin-left: 25px;
        margin-top: 2px;
    }
`
